<template>
  <div class="page">
    <div class="page__content">
      <PageHeader variant="gray">A caminho do certificado!</PageHeader>

      <PageContainer center class="mt-5 mb-5">
        <p class="mb-4">Precisamos confirmar algumas informações que serão utilizadas para <strong>gerar suas futuras certificações</strong>. Preencha com atenção.</p>

        <form @submit.prevent="submit" style="position: relative">
          <LoadingBox v-if="isLoading" />

          <div class="row">
            <div class="col-12">
              <PrimaryInput
                v-model="form.name"
                placeholder="Nome completo"
                :validation="$v.form.name"
                :focus="true"
                :ucwords="true"
              />
            </div>

            <div class="col-md-6">
              <PrimaryInput
                v-model="form.birthdate" :validation="$v.form.birthdate"
                type="tel"
                placeholder="Nascimento"
                mask="##/##/####"
              />
            </div>

            <div class="col-md-6">
              <PrimarySelect
                v-model="form.gender"
                :validation="$v.form.gender"
                placeholder="Gênero"
              >
                <option
                  v-for="gender in genders"
                  :key="gender"
                >{{ gender }}</option>
              </PrimarySelect>
            </div>
          </div>
        
          <SecondaryButton type="submit" :disabled="$v.$invalid">Salvar</SecondaryButton>
        </form>
      </PageContainer>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import LoadingBox from '@/components/layout/LoadingBox'
  import PageContainer from '@/components/layout/page/PageContainer'
  import PageHeader from '@/components/layout/page/PageHeader'
  import PrimaryInput from '@/components/form/PrimaryInput'
  import PrimarySelect from '@/components/form/PrimarySelect'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import userPersonalConfirmationRules from '@/validations/user/userPersonalConfirmationRules'
  import { getPreviousUrl } from '@/utils/redirector'

  export default {
    components: {
      PageContainer,
      PageHeader,
      PrimaryInput,
      SecondaryButton,
      PrimarySelect,
      LoadingBox,
    },

    data: () => ({
      isLoading: false,

      genders: [
        'Masculino',
        'Feminino',
        'Homem transgênero',
        'Mulher Transgênero',
        'Cisgênero',
        'Não binário',
        'Não sei responder',
        'Prefiro não responder',
        'Outros',
      ],

      form: {
        name: '',
        birthdate: '',
        gender: ''
      }
    }),

    validations: { form: userPersonalConfirmationRules },

    mounted () {
      if (this.user.is_personal_infos_filled) {
        return this.$router.replace({ name: 'home' })
      }

      this.form.name = this.user.name
    },

    computed: {
      ...mapGetters('user', ['user'])
    },

    methods: {
      ...mapActions('user', ['updateUser']),

      async submit () {
        this.isLoading = true

        await this.updateUser(this.form)

        this.isLoading = false

        this.$router.replace(getPreviousUrl())
      }
    }
  }
</script>

<style scoped lang="scss">
@import "~@/assets/sass/variables";

.page {
  // &:before {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(#000, .8);
  //   z-index: 1000;
  // }

  &__content {
    color: $white300;
    // position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1001;
  }
}
</style>